import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AmplitudeService } from "@shared/services/amplitude.service";
import { RegistrationService } from "@shared/services/registration.service";
import { APP_CONFIG, AppConfig } from "@src/app/app-config.module";
import { NGXLogger } from "ngx-logger";

@Component({
    selector: 'applicant-pre-dotfile-page',
    templateUrl: './applicant-pre-dotfile-page.component.html',
    styleUrl: './applicant-pre-dotfile-page.component.scss'
})
export class ApplicantPreDotfilePageComponent implements OnInit {

    loading = false;
    verificationPortalLink: string;
    textLabel: string;
    idvHelpPageUrl: string = null;
    privacyPolicyLink: string = null;
    inEarlyAccessPhase: boolean;

    constructor (
        @Inject(APP_CONFIG) private readonly config: AppConfig,
        private readonly registrationService: RegistrationService,
        private readonly amplitudeService: AmplitudeService,
        private readonly logger: NGXLogger,
        private readonly route: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.registrationService.deactivateProgressBar();
        this.verificationPortalLink = this.route.snapshot.data.verificationPortalData.portalLink;
        this.textLabel = this.route.snapshot.data.verificationPortalData.multipleVerifications ? 'MULTIPLE' : 'SINGLE';
        this.inEarlyAccessPhase = this.route.snapshot.data.verificationPortalData.inEarlyAccessPhase;

        switch (this.registrationService.getCountryOfIncorporation()) {
            case "GBR":
                this.privacyPolicyLink = this.config.privacyPolicyLink.en;
                this.idvHelpPageUrl = this.config.registrationProcessHelpURLs.fallback;
                break;
            case "ITA":
                this.privacyPolicyLink = this.config.privacyPolicyLink.it;
                this.idvHelpPageUrl = this.config.registrationProcessHelpURLs.ITA;
                break;
            default:
                this.privacyPolicyLink = this.config.privacyPolicyLink.fallback;
                this.idvHelpPageUrl = this.config.registrationProcessHelpURLs.fallback;
                break;
        }

        if(!this.verificationPortalLinkAvailable()) {
            this.amplitudeService.trackDotfileLinkNotAvailable();
        }
    }

    verificationPortalLinkAvailable(): boolean {
        return Boolean(this.verificationPortalLink);
    }

    proceedToVerificationPortal() {
        this.logger.debug("Opening verification portal", this.verificationPortalLink);
        this.amplitudeService.trackOpenDotfilePortal().promise.finally(() => {
            window.open(this.verificationPortalLink, "_self");
        });
    }

}
